export { default as Highlighter } from './Highlighter';
